import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class GlobalsService {
  // Local
  // dataUrl = 'http://localhost/salud/';

  // PROD
  dataUrl = 'https://saluddigitalprodapi-dycqcpdyhwbsa6dr.eastus2-01.azurewebsites.net/';
  sa = 'https://saluddigitalprodstorage.blob.core.windows.net/uploadedfiles';

  // TEST
  // dataUrl = 'https://xworks-salud-be-g8h8b6agd5bweheg.canadacentral-01.azurewebsites.net/';
  // sa = 'https://xworkssa.blob.core.windows.net/uploadedfiles';
  
  
  fileUrl = this.sa + '/uploadedfiles/';

  iconUrl = this.sa + '/icons/';

  pwaUrl = 'http://www.xworks.com';

  // fileUrl = this.sa + '/uploadedfiles/';

  loginData = {
    access_token: '',
  };

  currentRole = '';
  messageId = '';
}
